module.exports = __webpack_public_path__ + "account/media/confetto.22338620.webm";